import { useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { accountSubscriptionApi } from "@/react/api/accountSubscriptionApi";
import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { UPGRADE_PATHS } from "../constants";
import { useAccountPaymentProcessorsApi } from "./useAccountPaymentProcessorsApi";

const i18nRoot = "pricing_plans.upgrade_modal";

interface LoadingMessage {
  subtitle: string;
  title: string;
}

export const useRenewalHandler = (source?: string) => {
  const history = useHistory();
  const { createCheckoutSession } = useAccountPaymentProcessorsApi();
  const { refetchCurrentPlan } = useCurrentPlanApi();
  const [loadingMessage, setLoadingMessage] = useState<LoadingMessage>({
    title: t([i18nRoot, "loading.loading"]),
    subtitle: "",
  });

  const attemptRenewal = async (planId: number) => {
    try {
      setLoadingMessage({
        title: t([i18nRoot, "loading.loading"]),
        subtitle: "",
      });

      await accountSubscriptionApi.renew(planId);
      await refetchCurrentPlan();

      history.push(UPGRADE_PATHS.UPGRADE_SUCCESSFUL);
    } catch {
      setLoadingMessage({
        title: t([i18nRoot, "stripe_checkout_title"]),
        subtitle: "",
      });

      createCheckoutSession({
        plan_id: planId,
        source: source || "",
      });
    }
  };

  return {
    attemptRenewal,
    loadingMessage,
  };
};
